export const deletedProduct = {
    deleted: {
        identifier: "deleted",
        image: {
            id: 1,
            warhole_id: 1,
            thumbnails: {
                thumbnail: "",
                small: "",
                medium: "",
                large: "",
                full: "",
            },
        },
        min_price: 3400,
        max_price: 34010,
        language: "es-MX",
        name: "Producto eliminado",
        url: "",
    },
};
//# sourceMappingURL=deletedProduct.js.map